module.exports = __webpack_public_path__ + "img/left-inquiry-image.479e2876.svg";